export class OpenModalSavedFiltersAction {
    public static readonly type = '[JobsPlacements] Open modal saved filters action';
}
